"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isPadlet = exports.firstAuthorName = exports.isAmpablePage = exports.isPage = exports.isPlainText = exports.isText = exports.isCode = exports.isPdf = exports.isExcelSpreadsheet = exports.isPowerpointPresentation = exports.isWordDocument = exports.isDocument = exports.isVideo = exports.isAudio = exports.isFile = exports.isPhoto = exports.isStatic = void 0;
function isStatic(link) {
  return link.content_type != 'text/html';
}
exports.isStatic = isStatic;
function isPhoto(link) {
  return link.content_category === 'photo';
}
exports.isPhoto = isPhoto;
function isFile(link) {
  return link.content_category === 'file';
}
exports.isFile = isFile;
function isAudio(link) {
  return link.content_category === 'audio';
}
exports.isAudio = isAudio;
function isVideo(link) {
  return link.content_category === 'video';
}
exports.isVideo = isVideo;
function isDocument(link) {
  return link.content_category === 'document';
}
exports.isDocument = isDocument;
function isWordDocument(link) {
  const wordExtensions = ['doc', 'docx', 'dot', 'dotx', 'docm', 'dotm'];
  return wordExtensions.includes(link.extension || '');
}
exports.isWordDocument = isWordDocument;
function isPowerpointPresentation(link) {
  const powerpointExtensions = ['ppt', 'pptx', 'ppam', 'potx', 'pps', 'ppsx', 'ppsm', 'pptm'];
  return powerpointExtensions.includes(link.extension || '');
}
exports.isPowerpointPresentation = isPowerpointPresentation;
function isExcelSpreadsheet(link) {
  const excelExtensions = ['xls', 'xlsx', 'xlsm', 'xlsb'];
  return excelExtensions.includes(link.extension || '');
}
exports.isExcelSpreadsheet = isExcelSpreadsheet;
function isPdf(link) {
  return link.content_subcategory === 'pdf';
}
exports.isPdf = isPdf;
function isCode(link) {
  return link.content_subcategory === 'code';
}
exports.isCode = isCode;
function isText(link) {
  return link.content_subcategory === 'text';
}
exports.isText = isText;
function isPlainText(link) {
  return isCode(link) || isText(link);
}
exports.isPlainText = isPlainText;
function isPage(link) {
  return link.content_category === 'page';
}
exports.isPage = isPage;
function isAmpablePage(link) {
  return isPage(link) && !!link.amp_url;
}
exports.isAmpablePage = isAmpablePage;
function isPadlet(link) {
  return link.content_subcategory === 'padlet';
}
exports.isPadlet = isPadlet;
function firstAuthorName(link) {
  if (link.authors && link.authors[0] && link.authors[0].name) {
    return link.authors[0].name;
  }
  return '';
}
exports.firstAuthorName = firstAuthorName;